export interface Saas extends SaasHttp, DataTransferEntity {
    description?: string;
    icon?: string;
}

export interface SaasHttp extends DataTransferEntity {
    name?: string;
    solution?: string;
    // 2 chars ISO 3166 country codes (UPPERCASE)
    // eg: ['FR', 'CA', 'GB', 'US']
    countryCodes?: string[];
    address?: string;
    legalGuarantees?: string[];
}

export enum ContractHolder {
    UNKNOWN = 'UNKNOWN',
    CLARANET = 'CLARANET',
    CLIENT = 'CLIENT'
}

export interface DataTransferEntity {
    proofLink?: string;
    declaredAt?: string;
    declaredBy?: string;
    effectiveAt?: string;
}

export type Office = Entity & DataTransferEntity;

export interface Entity {
    name?: string;
    address?: string;
    // 2 chars ISO 3166 country codes (UPPERCASE)
    // eg: ['FR', 'CA', 'GB', 'US']
    countryCodes?: string[];
    legalGuarantees?: string[];
}

export interface CloudPartner {
    name?: string;
    address?: string;
    countryCodes?: string[];
    legalGuarantees?: string[];
    contractHolder?: ContractHolder;
}

export interface Processing {
    name?: string;
    solution?: string; // Deprecated.
    dataCategories?: string[];
    peopleCategories?: string[];
    hasHealthData?: boolean;
}

export interface Company {
    dpoId?: string;
    dpoEmail?: string;
    dpoName?: string;
    responsibility?: Responsibility;
    accountingId?: string;
    name?: string;
    address?: string;
    phoneNumber?: string;
    responsibilities?: Responsibility[];
}

export enum Status {
    YES = 'YES',
    NO = 'NO',
    UNDECLARED = 'UNDECLARED',
}

export enum Responsibility {
    HEAD = 'HEAD',
    COHEAD = 'COHEAD',
    SUBCONTRACTOR = 'SUBCONTRACTOR'
}

export enum LegalGuaranteesTypes {
    DEFAULT = 'DEFAULT',
    SAAS = 'SAAS',
    CLOUD_PARTNER = 'CLOUD_PARTNER'
}

export enum AuthorizedLocation {
    // order matter
    FRANCE = 'FRANCE_ONLY',
    ALL_EU = 'ALL_EU',
    ADEQUATE_COUNTRIES_ONLY = 'ADEQUATE_COUNTRIES_ONLY',
    ALL_WORLD = 'ALL_WORLD',
    UNDECLARED = 'UNDECLARED',
}

export class GdprRaw {
    project?: string;
    status?: Status;
    company?: Company;
    processings?: Processing[];
    offices?: Office[];
    excludedOffices?: Office[];
    datacenters?: Entity[];
    cloudPartners?: CloudPartner[];
    saas?: Saas[];
    excludedSaas?: Saas[];
    tags?: string[];
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    declaredAt?: string;
    declaredBy?: string;
    dataTransferAuthorizations?: DataTransferAuthorization[];
    subcontracting?: Subcontracting;
}

export enum AgreementType {
    UNDECLARED = 'UNDECLARED',
    PRIOR_AGREEMENT = 'PRIOR_AGREEMENT',
    PRIOR_INFORMATION = 'PRIOR_INFORMATION',
}
export interface DataTransferAuthorization {
    authorizedLocation: AuthorizedLocation;
    agreementType: AgreementType;
}

export interface DataTransferAuthorizationTemplate extends DataTransferAuthorization {
    text?: string;
    allowedCountry: string[];
    tooltip?: string;
    hasAgreementType?: boolean;
    isFr: boolean;
}

export interface Subcontracting {
    status: Status;
    agreementType: AgreementType;
}
